let prodsChange = 0;

setInterval(() => {
  const filters = new URLSearchParams(window.location.href).getAll('filter.v.option.color');
  
  if(filters.length == 0) return;
  
  const products = document.querySelectorAll("#product-grid .product-card-wrapper");

  if(products.length == prodsChange) return;

  prodsChange = products.length;

  [...products].forEach(prod => {
    if(prod.dataset.color && !filters.includes(prod.dataset.color)) prod.closest("li").remove();  
  })  
}, 300)